import { FlexBox, WarningCard } from '@/local/components'
import { WarningTriangle } from '@/icons'

import { useTexts } from '../useTexts'

export function TrackingLinkFailed() {
  const texts = useTexts()

  return (
    <FlexBox column vAlignContent="top" padding="8px 32px" style={{ flexShrink: 0 }}>
      <WarningCard
        preset="alert"
        title={texts.trackingLinkFailureTitle}
        Icon={<WarningTriangle size={14} color="$pureWhite" background="$outrageousRed" />}
        description={texts.trackingLinkFailureDescription}
      />
    </FlexBox>
  )
}
